/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TaxRateModel as DigiworkMaitreDPosDtoMenuTaxRateModel } from '../../models/Digiwork/MaitreD/Pos/DTO/Menu/tax-rate-model';

export interface UpdateTaxRate$Params {
      body?: DigiworkMaitreDPosDtoMenuTaxRateModel
}

export function updateTaxRate(http: HttpClient, rootUrl: string, params?: UpdateTaxRate$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, updateTaxRate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

updateTaxRate.PATH = '/api/gmn/Menu/updatetaxrate';
